import { render, staticRenderFns } from "./TenantEditAccess.vue?vue&type=template&id=79f5e920&scoped=true&"
import script from "./TenantEditAccess.vue?vue&type=script&lang=js&"
export * from "./TenantEditAccess.vue?vue&type=script&lang=js&"
import style0 from "./TenantEditAccess.vue?vue&type=style&index=0&id=79f5e920&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f5e920",
  null
  
)

export default component.exports